import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import { getDrawerPaneWidth } from 'owa-drawer';
import { resolveVisibleDrawerMount } from 'owa-drawer/lib/selectors/getDrawerPaneAnchor';
import { getFlexPaneWidth } from 'owa-suite-header-store';
import { isUnderRibbonAddinsPane } from './isUnderRibbonAddinsPane';

export const updateFlexPaneInternalWidth = (
    flexPaneId?: string,
    targetWindow: Window = window
): void => {
    const width = isCapabilityEnabled(newHeaderCapability)
        ? getDrawerPaneWidth(flexPaneId, targetWindow)
        : getFlexPaneWidth(flexPaneId);

    // Scope `--flexPaneWidth` to the drawer's own anchor instead of the document root, so the
    // background (which also reads this variable) doesn't shift when the drawer resizes.
    if (isUnderRibbonAddinsPane(flexPaneId)) {
        const resolvedMount = resolveVisibleDrawerMount(targetWindow, flexPaneId);
        if (resolvedMount) {
            resolvedMount.mountNode.style.setProperty('--flexPaneWidth', `${width}px`);
            return;
        }
    }

    // Fallback: write to document root (non-addins panes, under-ribbon disabled, or anchor absent)
    targetWindow.document.documentElement.style.setProperty('--flexPaneWidth', `${width}px`);
};
